import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  ReportRequestParams,
  TextResponse,
} from 'src/app/common/dtos/reports.dto';
import { APICoreService } from 'src/app/common/services/api-core/api-core.service';
import { ModalComponent } from '../../modals/modal/modal.component';

@Component({
  selector: 'app-proforms-text-response',
  standalone: false,

  templateUrl: './proforms-text-response.component.html',
  styleUrl: './proforms-text-response.component.scss',
})
export class ProformsTextResponseComponent
  implements OnInit, OnChanges, AfterContentChecked
{
  @Input() requestParams: ReportRequestParams;

  @Input() questionTitle: string;

  @Input() fieldId: string;

  @ViewChild('responseModal') modal: ModalComponent;

  modalResponse = '';

  isLoading = true;

  params: ReportRequestParams[] = [];

  currentPage = 1;

  totalResponses = 0;

  responses: TextResponse[];

  constructor(
    private apiService: APICoreService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.getResponses(this.requestParams);
  }

  ngOnChanges(change: SimpleChanges) {
    if (
      change['requestParams'] &&
      change['requestParams'].firstChange === false
    ) {
      this.getResponses(this.requestParams);
    }
  }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  getResponses(params: ReportRequestParams) {
    this.isLoading = true;
    this.apiService
      .getRequest('reporting/load-report', {
        report: 'proformTextResponses',
        ...params,
      })
      .subscribe((response) => {
        this.totalResponses = response.totalCount;
        this.responses = response.items;
        this.isLoading = false;
      });
  }

  paginationChange() {
    const params = {
      ...this.requestParams,
      page: this.currentPage,
    };
    this.getResponses(params);
  }

  hasOverflow(elementIndex: number) {
    const element = document.getElementById(
      `response-${this.fieldId}-${elementIndex}`
    );

    if (element) {
      if (element.clientHeight >= 80) {
        return (
          element.clientHeight < element.scrollHeight ||
          element.clientWidth < element.scrollWidth
        );
      }
    }
    return false;
  }

  openResponseModal(responseText: string) {
    this.modal.config.titleText = this.questionTitle;
    this.modal.config.headerClass = [
      'modal-header',
      'bg-primary',
      'text-white',
    ];
    this.modal.config.showFooter = false;
    this.modal.config.options = { centered: true };
    this.modalResponse = responseText;

    this.modal.open();
  }
}
